import { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { IRatingNotification } from '../interfaces';
import { checkRatingNotification } from '../api';

const initialValues: IRatingNotification = {
  show: false,
  partners: { required: false, message: '', list: [] },
  personal: { required: false, message: '', list: [] },
  defectActUgo: { required: false, message: '', list: [] },
};

export function useCheckRatingNotification(onCheck?: (response: IRatingNotification) => void) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IRatingNotification>(initialValues);

  const { addError } = useError();

  const checkNotification = async () => {
    setLoading(true);

    try {
      const rating = await checkRatingNotification();

      setData(rating);
      onCheck?.(rating);

      return rating;
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkNotification();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { loading, data, checkNotification };
}
